import React from "react";
import "../../styles/About.css";
import CompanyBuilding from "../../assets/Company Building.jpg";
import ShippingContainers from "../../assets/Shipping Containers.jpg";
import overviewIcon from "../../assets/overview-icon.png";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <div className="abt-container">
      {/* Image Slider */}
      <div className="abt-image-slider">
        <img src="/images/slider-image.jpg" alt="About Us Slider" />
      </div>

      {/* Main Content Container */}
      <div className="abt-content">
        {/* Content Card with title inside */}
        <div className="abt-card">
          {/* Title with Icon - Added with blue style */}
          <div className="abt-title-header">
            <img src={overviewIcon} alt="Overview" className="abt-title-icon rotate-on-hover" />
            <div className="abt-vertical-line"></div>
            <h3 className="abt-title-text">Overview</h3>
          </div>
          
          {/* Left Side - Images */}
          <div className="abt-left">
            <div className="abt-image-container first-image">
              <img src={CompanyBuilding} alt="Company Building" className="abt-img" />
            </div>
            <div className="abt-image-container second-image">
              <img src={ShippingContainers} alt="Shipping Containers" className="abt-img" />
            </div>
          </div>

          {/* Right Side - Text Content */}
          <div className="abt-right">
            <p className="abt-text">
              Puyvast Logistics Pvt Ltd., an associate of Puyvast Chartering B.V., Netherlands, has over a century of experience in the shipping industry.
            </p>
            <p className="abt-text">
              With offices, agencies, stockyards, and infrastructure at major Indian ports, Puyvast provides comprehensive logistic solutions to a diverse clientele.
            </p>
            <p className="abt-text">
              A team of specialized personnel manages vessels across multiple shipping lines, offering break bulk support for international trade.
            </p>
            <p className="abt-text-bold">
              For the best testimonials, look no further than our valued clients themselves.
            </p>
          </div>
        </div>
      </div>

      {/* Footer - Same as homepage */}
      <footer className="footer">
        <div className="footer-container">
          {/* Left Section - CIN & Links */}
          <div className="footer-left">
            <p>CIN Number: U63030KA2022PTC161825</p>
            <p>
              <Link to="/privacy-statement" className="footer-link">Privacy Statement</Link> |
              <Link to="/terms-of-use" className="footer-link"> Terms Of Use</Link>
            </p>
          </div>

          {/* Center - Copyright */}
          <div className="footer-center">
            <p>© {new Date().getFullYear()} ONEVEGA Systems (India) Pvt Ltd.</p>
          </div>

          {/* Right Section - Registered Office */}
          <div className="footer-right">
            <p><strong>Registered Office</strong></p>
            <p>Puyvast Logistics Pvt. Ltd.</p>
            <p>PuyVast House</p>
            <p> 4th Floor ,#6, Harris Road, Benson Town, 
              <br></br>Bangalore - 560 046.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default About;